import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Modal from 'react-modal';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import TagManager from 'react-gtm-module'

import FreeTrial from './pages/freeTrial/FreeTrial';
import RegisterDomain from './pages/registerDomain/RegisterDomain';
import RegisterEmailService from './pages/registerEmailService/RegisterEmailService';
import WizardPage from './pages/WizardPage';
import LinkVerification from './pages/validate/LinkVerification';
import Completion from './pages/completion/Completion';
import TrialVerification from './pages/freeTrial/TrialVerification';
import PricingPreFill from './pages/pricingPrefill/PricingPreFill';
import NotFound from './pages/errorPages/NotFound';

import './App.scss';

const tagManagerArgs = { gtmId: 'GTM-WD2FBVG' }


TagManager.initialize(tagManagerArgs);

function App() {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
    Modal.setAppElement('#root');
    window.dataLayer.push({
        event: 'pageview',
        page: {
            url: document.location.pathname,
            title: ''
        }
    });
    return (
        <Elements stripe={stripePromise}>
            <BrowserRouter basename={'/signup'}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={() => <Redirect to="/need-domain" />}
                    />
                    <Route
                        exact
                        path="/need-domain"
                        render={() => <RegisterDomain />}
                    />
                    <Route
                        exact
                        path="/need-mail"
                        render={() => <RegisterEmailService />}
                    />

                    <Route exact path="/trial" render={() => <FreeTrial />} />
                    <Route
                        exact
                        path="/trial-verification"
                        render={() => <TrialVerification />}
                    />
                    <Route
                        path="/verify/:id/:token"
                        render={() => <LinkVerification />}
                    />
                    <Route
                        exact
                        path="/completed"
                        render={() => <Completion />}
                    />
                    <Route
                        exact
                        path="/completed/domain"
                        render={() => <Completion />}
                    />
                    <Route
                        exact
                        path="/completed/email"
                        render={() => <Completion />}
                    />
                    <Route
                        exact
                        path="/completed/trial"
                        render={() => <Completion />}
                    />
                    <Route path="/registration" render={() => <WizardPage />} />

                    <Route
                        path="/options/:users/:volume/:flavor"
                        render={() => <PricingPreFill />}
                    />

                    <Route render={() => <NotFound />} />
                </Switch>
            </BrowserRouter>
        </Elements>
    );
}

export default App;
